export default function Page404() {
  return (
    <div style={{ marginTop: 40, textAlign: 'center' }}>
      <div style={{ fontWeight: 900, fontSize: 80 }}>404</div>
      <div style={{ fontWeight: 100, fontSize: 20 }}>The page you're looking for doesn't exist.</div>
    </div>
  )
}